import React, { Component } from 'react';
import confetti from 'canvas-confetti';

class OffersV4Confetti extends Component {
    componentDidMount() {
        // Skip on the authenticated /loan-options page; confetti is only for the pre-auth offers page.
        if (window.location.hash.includes('loan-options')) return;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!prefersReducedMotion && !sessionStorage.getItem('offersV4ConfettiPlayed')) {
            sessionStorage.setItem('offersV4ConfettiPlayed', 'true');
            this.fire();
        }
    }

    componentWillUnmount() {
        this.stopped = true;
    }

    fire() {
        const colors = ['#5e79d9', '#a8bfff', '#f4b8a8', '#e87c4f'];
        const pill = confetti.shapeFromPath({
            path: 'M3 0 H9 A3 3 0 0 1 12 3 V3 A3 3 0 0 1 9 6 H3 A3 3 0 0 1 0 3 V3 A3 3 0 0 1 3 0 Z',
        });
        let count = 0;

        const burst = () => {
            if (this.stopped || count >= 5) return;
            count++;

            confetti({
                particleCount: 30,
                spread: 360,
                startVelocity: 30,
                origin: { x: Math.random(), y: Math.random() * 0.4 },
                colors,
                shapes: [pill],
                gravity: 0.8,
                ticks: 120,
                flat: false,
                scalar: 1.0,
            });

            setTimeout(burst, 300);
        };

        burst();
    }

    render() {
        return null;
    }
}

export default OffersV4Confetti;
